import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../hooks/useMain';
import Image from './common/image';

const ComingSoon = ({ withLink = true }) => {
	const { theme } = useMain();
	return (
		<main className='container'>
			<div className='row my-0'>
				<div className='col-md-10 offset-md-1 col text-center'>
					<Image
						className='w-100 my-0'
						fileName={`utility_${theme}/comingSoon.webp`}
					/>
					{withLink && (
						<Link
							className={`btn btn-lg btn-set2-${theme} mb-4`}
							to='/'>
							Take me back home!
						</Link>
					)}
				</div>
			</div>
		</main>
	);
};

export default ComingSoon;
